import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types/api';
import { Sweetener } from '../types/Sweetener';

const URL = '/v2/booking-sweeteners';

class SweetenerService {
  static getBookingSweeteners(
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<Sweetener>> {
    return axios.get(URL, config);
  }

  static getByFilterForAdmin(
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<Sweetener>> {
    return axios.get(`${URL}?includeDisabled=true`, config);
  }

  static patch(
    id: number,
    data: Sweetener,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<Sweetener>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static update(
    id: number,
    data: Sweetener,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<Sweetener>> {
    return axios.put(`${URL}/${id}`, data, config);
  }

  static create(
    data: Sweetener,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<Sweetener>> {
    return axios.post(URL, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig) {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { SweetenerService };
